import React from 'react';

import { ButtonsWrapper, Separator, TableCardButtonsWrapper } from 'Containers/App/CtaBar/styled';
import { useCompareContext } from 'Contexts/compareContext';
import { useProfileContext } from 'Contexts/profileContext';
import { Button } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';

import ProfileNavigator from './ProfileNavigator';
import { PageHeaderContainer } from '../styled';

type Props = {
  hasHealthPlanSection: boolean;
  animate?: boolean;
  numTokens: number;
};

/**
 *
 * @param props: Props
 * @returns JSX element to show cards and other information
 */
const ResultsReviewHeader = ({ hasHealthPlanSection, numTokens, animate }: Props) => {
  const { tableViewEnabled, setTableViewEnabled } = useProfileContext();
  const { resetComparedPlans } = useCompareContext();
  const handleTableViewButtonClick = () => {
    setTableViewEnabled(true);
    resetComparedPlans();
  };

  return hasHealthPlanSection ? (
    <PageHeaderContainer numTokens={numTokens || 0} animate={animate || false}>
      <ButtonsWrapper justifyContent="start">
        <ProfileNavigator />
        <Separator />
        <TableCardButtonsWrapper className="right-side-button">
          <Button
            className={tableViewEnabled ? 'primary' : 'secondary'}
            size="small"
            onClick={handleTableViewButtonClick}
            data-testid="results-table-btn"
            buttonType={tableViewEnabled ? 'primary' : 'secondary'}
            color="blue"
            iconProps={{ color: tableViewEnabled ? '--colors-gray-0' : '--text-black' }}
            iconLeft="GridNine"
          >
            <Text field="health_section.button_text.table" />
          </Button>

          <Button
            className={tableViewEnabled ? 'secondary' : 'primary'}
            size="small"
            onClick={() => setTableViewEnabled(false)}
            data-testid="results-card-btn"
            buttonType={tableViewEnabled ? 'secondary' : 'primary'}
            color="blue"
            iconProps={{ color: tableViewEnabled ? '--text-black' : '--colors-gray-0' }}
            iconLeft="CardsThree"
          >
            <Text field="health_section.button_text.card" />
          </Button>
        </TableCardButtonsWrapper>
      </ButtonsWrapper>
    </PageHeaderContainer>
  ) : null;
};

export default ResultsReviewHeader;
